import { isMobile } from "app/assets/javascripts/utils/breakpoints"
import { googletag } from "./shared"
import { ADS, adStatuses, currentRefreshInterval, getFullPath } from "./status"

const chooseAdPath = (status, ad) => {
  status.initialized = true
  status.activePath = ad.paths[currentRefreshInterval] || ad.paths.default
}

const initializeAd = (status, ad) => {
  const { id, sizes } = ad
  const path = getFullPath(status.activePath)

  googletag.cmd.push(function () {
    googletag.defineSlot(path, sizes, id).setTargeting(id, "true").addService(googletag.pubads())
  })
}

export const initializeResponsiveAds = () => {
  if (isMobile()) {
    Object.keys(ADS.mobile).forEach((key) => {
      const status = adStatuses.mobile[key]
      const ad = ADS.mobile[key]
      if (!status.initialized) {
        chooseAdPath(status, ad)
        initializeAd(status, ad)
      }
    })
  } else {
    Object.keys(ADS.desktop).forEach((key) => {
      const status = adStatuses.desktop[key]
      const ad = ADS.desktop[key]
      if (!status.initialized) {
        chooseAdPath(status, ad)
        initializeAd(status, ad)
      }
    })
  }
}

initializeResponsiveAds()
